import React from 'react';

const AnnouncementFooter: React.FC = () => (
  <footer className="sa-footer">
    <div className="sa-footer__divider" />
    <div className="sa-footer__copy">
      <span>{new Date().getFullYear()}</span>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
        <circle cx="8" cy="8" r="7" stroke="#6C757D" strokeWidth="1.2" />
        <path d="M10.5 6.4a3 3 0 1 0 0 3.2" stroke="#6C757D" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
      <span>MİDA</span>
    </div>
  </footer>
);

export default AnnouncementFooter;